/**
 * Lodash
 */
window._ = require('lodash');

/**
 * Jquery and Bootstrap
 */
try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
} catch (e) {
}

/**
 * Other Plugins
 */
window.select2 = require('../../public/limitless/global_assets/js/plugins/forms/selects/select2.min.js');
require('../../public/limitless/global_assets/js/plugins/pickers/bootstrap-datepicker/js/bootstrap-datepicker.min');
require('../../public/limitless/global_assets/js/plugins/pickers/bootstrap-datepicker/locales/bootstrap-datepicker.tr.min');
window.moment = require('moment-timezone');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
// window.axios = require('axios');
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.io = require('socket.io-client');

window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: window.websocketUrl || window.location.hostname,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 6000,
});

/*
 Lagina Vue App
 */
require('./lagina')
